import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { isTouch } from 'Lib/istouch/istouch';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';

const $parent = $('.collections');
const $pagenavAjax = $('.pagenav-ajax');
const sItem = '.collections__item';
const sImgForLoad = '.collection__series-image, .collection__pic';

function loadImg() {
    const $collectionSeries = $(sImgForLoad);

    onScreen($collectionSeries, ($el) => {
        if (!$el.hasClass('collection__series-image_empty')) {
            $el.addClass('collection__image-load');
        }

        loadSrcOrBg($el);
    });
}

loadImg();

$pagenavAjax.each(function () {
    $(this).on('eksmoPagenavAjax', loadImg);
});

// Показываем модалку "Поделиться подборкой"
$parent.on('eksmoCollectionShare', sItem, (e, id, link, mailLink, vkLink, tgLink, okLink, twLink) => {
    modalShare(id, link, mailLink, vkLink, tgLink, okLink, twLink);
});

// Показываем модалку "Редактирование подборки"
$parent.on('eksmoCollectionEdit', sItem, (e, id, name, description = '') => {
    modalEdit(id, name, description);
});

// Показываем модалку "Удаление подборки"
$parent.on('eksmoCollectionDelete', sItem, (e, id, name) => {
    modalDelete(id, name);
});

// Нажатие на кнопку c тремя точками на мобилке на элементе списка подборок
$parent.on('click', '.collections__collection-personal-btn-box', function () {
    if (getW() < eksmoBP.xsMax || isTouch()) {
        const $modalContent = $('.collections__mobile-menu-content');
        const $collectionsItem = $(this).closest('.collections__item');

        $modalContent.attr({
            'data-id': $collectionsItem.attr('data-id'),
            'data-link': $collectionsItem.find('.collection__link').attr('href'),
            'data-href-mail': $collectionsItem.attr('data-href-mail'),
            'data-name': $collectionsItem.find('.collection__name').text(),
            'data-description': $collectionsItem.attr('data-description'),
            'data-vk-href': $collectionsItem.attr('data-vk-href'),
            'data-tg-href': $collectionsItem.attr('data-tg-href'),
            'data-tw-href': $collectionsItem.attr('data-tw-href'),
            'data-ok-href': $collectionsItem.attr('data-ok-href'),
        });

        $.fancybox.close();

        $.fancybox.open({
            type: 'html',
            src: $('.collections__modal-mobile-menu').html(),
            baseClass: 'collections__fancybox collections__fancybox_no-offset',
            touch: false,
        });
    }
});

// Нажатие на кнопку "Поделиться" в мобильном меню
$(document).on('click', '.collections__mobile-menu-share', function () {
    const $mobileMenuContent = $(this).closest('.collections__mobile-menu-content');

    modalShare($mobileMenuContent.attr('data-id'), $mobileMenuContent.attr('data-link'), $mobileMenuContent.attr('data-href-mail'), $mobileMenuContent.attr('data-vk-href'), $mobileMenuContent.attr('data-tg-href'), $mobileMenuContent.attr('data-ok-href'), $mobileMenuContent.attr('data-tw-href'));
});

// Нажатие на кнопку "Редактировать" в мобильном меню
$(document).on('click', '.collections__mobile-menu-edit', function () {
    const $mobileMenuContent = $(this).closest('.collections__mobile-menu-content');

    modalEdit($mobileMenuContent.attr('data-id'), $mobileMenuContent.attr('data-name'), $mobileMenuContent.attr('data-description'));
});

// Нажатие на кнопку "Удалить" в мобильном меню
$(document).on('click', '.collections__mobile-menu-delete', function () {
    const $mobileMenuContent = $(this).closest('.collections__mobile-menu-content');

    modalDelete($mobileMenuContent.attr('data-id'), $mobileMenuContent.attr('data-name'));
});

function modalShare(id, link, mailLink, vkLink, tgLink, okLink, twLink) {
    $('.collections__share-btn').attr('data-link', link);
    $('.collections__article-share .article-share__item-link[data-key="vk"]').attr('href', (typeof vkLink === 'string' ? vkLink : ''));
    $('.collections__article-share .article-share__item-link[data-key="tg"]').attr('href', (typeof vkLink === 'string' ? tgLink : ''));
    $('.collections__article-share .article-share__item-link[data-key="ok"]').attr('href', (typeof okLink === 'string' ? okLink : ''));
    $('.collections__article-share .article-share__item-link[data-key="tw"]').attr('href', (typeof twLink === 'string' ? twLink : ''));
    $('.collections__article-share .article-share__item-box_mail .article-share__item-link').attr('href', (typeof mailLink === 'string' ? mailLink : ''));
    $.fancybox.close();

    $.fancybox.open({
        type: 'html',
        src: $('.collections__modal-content-share').html(),
        baseClass: 'collections__fancybox',
        touch: false,
    });
}

function modalEdit(id, name, description) {
    $.fancybox.close();

    $.fancybox.open({
        type: 'html',
        src: $('.collections__modal-content-edit').html(),
        baseClass: 'collections__fancybox',
        touch: false,
    });

    $('.collections__edit-block [name=id]').val(id);
    $('.collections__edit-block [name=name]').val(name.trim());
    $('.collections__edit-block [name=description]').val(description.trim());
}

function modalDelete(id, name) {
    $.fancybox.close();

    $.fancybox.open({
        type: 'html',
        src: $('.collections__modal-content-delete').html(),
        baseClass: 'collections__fancybox',
        touch: false,
    });

    $('.collections__delete-form-description-name').html(name);
    $('.collections__delete-form [name=id]').val(id);
}

// Нажатие на кнопку "Удалить подборку" в модалке редактирования подборки
$(document).on('click', '.collections__edit-delete-link', function () {
    const $this = $(this);

    $this.hide();
    $this.closest('.collections__edit-block').find('.collections__edit-delete-form').show();
});

// Нажатие на кнопку "отмена" в форме удаления в модалке редактирования подборки
$(document).on('click', '.collections__edit-delete-form-btn--cancel', function () {
    const $editBlock = $(this).closest('.collections__edit-block');

    $editBlock.find('.collections__edit-delete-form').hide();
    $editBlock.find('.collections__edit-delete-link').show();
});

// Успешная отправка формы редактирования подборки
$(document).on('eksmoThisAjaxFormSuccess', '.collections__edit-form', () => {
    setTimeout(() => {
        window.location.reload(true);
    }, 1500);
})

// НЕ успешная отправка формы редактирования подборки
    .on('eksmoThisAjaxFormFail', (e, message) => {
        $.fancybox.close();

        if (typeof message === 'string') {
            $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${message}"</p></div>`);
        } else {
            $.fancybox.open(`
                <div>
                    <p class="text text_c-gray">Ошибка связи с сервером</p>
                    <p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p>
                </div>
            `);
        }
    });

// Успешная отправка формы удаления в модалке редактирования подборки
$(document).on('eksmoThisAjaxFormSuccess', '.collections__edit-delete-form', () => {
    window.location.reload(true);
})

// НЕ успешная отправка формы удаления в модалке редактирования подборки
    .on('eksmoThisAjaxFormFail', (e, message) => {
        $.fancybox.close();

        if (typeof message === 'string') {
            $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${message}"</p></div>`);
        } else {
            $.fancybox.open(`
                <div>
                    <p class="text text_c-gray">Ошибка связи с сервером</p>
                    <p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p>
                </div>
            `);
        }
    });

// Успешная отправка формы удаления
$(document).on('eksmoThisAjaxFormSuccess', '.collections__delete-form', () => {
    window.location.reload(true);
})

// НЕ успешная отправка формы удаления
    .on('eksmoThisAjaxFormFail', (e, message) => {
        $.fancybox.close();

        if (typeof message === 'string') {
            $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${message}"</p></div>`);
        } else {
            $.fancybox.open(`
                <div>
                    <p class="text text_c-gray">Ошибка связи с сервером</p>
                    <p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p>
                </div>
            `);
        }
    });

// Успешная отправка формы создания подборки в модальном окне
$(document).on('eksmoThisAjaxFormSuccess', '.collections__create-form', () => {
    setTimeout(() => {
        window.location.reload(true);
    }, 1500);
})
    // НЕ успешная отправка формы создания
    .on('eksmoThisAjaxFormFail', (e, message) => {
        $.fancybox.close();

        if (typeof message === 'string') {
            $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${message}"</p></div>`);
        } else {
            $.fancybox.open(`
                <div>
                    <p class="text text_c-gray">Ошибка связи с сервером</p>
                    <p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p>
                </div>
            `);
        }
    });